import { gql } from '@apollo/client'

const UPSERT_RECURRING_CHECKLIST_ITEM = gql`
  mutation upsertRecurringChecklistItem(
    $recurringItemInfo: RecurringChecklistItemInput!
    $nonprofitOrgId: Int!
  ) {
    upsertRecurringChecklistItem(
      recurringItemInfo: $recurringItemInfo
      nonprofitOrgId: $nonprofitOrgId
    ) {
      id
      dueDate
      owner {
        id
      }
      updatedAt
    }
  }
`

export default UPSERT_RECURRING_CHECKLIST_ITEM
